var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "search-bar" },
    [
      _c("button", { staticClass: "button", on: { click: _vm.onFocus } }, [
        _vm._v("\n        Search\n    ")
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "search" } }, [
        _vm.focussed
          ? _c(
              "form",
              {
                staticClass: "form",
                attrs: { action: "/search", method: "get" }
              },
              [
                _c("svg-magnifier"),
                _vm._v(" "),
                _c("input", {
                  attrs: { type: "hidden", name: "type", value: "product" }
                }),
                _vm._v(" "),
                _c("input", {
                  ref: "field",
                  staticClass: "search",
                  attrs: { type: "text", name: "q" },
                  domProps: { value: _vm.value }
                })
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }